import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SharedModule } from '../../shared/shared.module';
import { PartsScheduleComponent } from './parts-schedule.component';
import { PartsScheduleRoutingModule } from './parts-schedule-routing.module';

@NgModule({
  declarations: [PartsScheduleComponent],
  imports: [
    CommonModule,
    SharedModule,
    PartsScheduleRoutingModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ]
})
export class PartsScheduleModule { }
